
import Vue from 'vue'
import router from '@/router'
import jQuery from 'vue-jquery'
Vue.use(jQuery);

export default {
  adminLoginAttempt({
    dispatch
  }, payload) { //not used anymore
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      self: payload.self
    }
    if (!payload.checkbox_remember_me) {
      dispatch('adminLogin', newPayload);
    } else {
      // localStorage.setItem('remember_me', true);
      dispatch('adminLogin', newPayload);
      if (payload.self.$refs.login)
        payload.self.$vs.loading.close(payload.self.$refs.login.$el);
    }
  },
  loginAttempt({
    dispatch
  }, payload) {

    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      self: payload.self
    }
    dispatch('login', newPayload);
    if (payload.self.$refs.login)
      payload.self.$vs.loading.close(payload.self.$refs.login.$el);
  },
  adminLogin({
    commit,
    state
  }, payload) { //not used anymore
    localStorage.setItem('permissions', '');
    localStorage.setItem('userSiteInfo', '');
    localStorage.setItem('Current_User_Id', '');

    if (state.isUserLoggedIn()) {
      if (payload.self.$refs.login)
        payload.self.$vs.loading.close(payload.self.$refs.login.$el);
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }
    payload.self.$signIn(payload.self, payload.userDetails.email, payload.userDetails.password, (result) => {
      var data = result;
      var localStorageString = JSON.stringify(data);
      localStorage.setItem('userInfo', localStorageString);

      localStorage.setItem('Current_User_Id', data.currentUserId);
      localStorage.setItem('DisplayName', data.displayName);
      localStorage.setItem("accessToken", data.apiToken);

      payload.self.$getSites(self, function () {
        payload.self.$getProfilePicture(self, function () {
          var userInfo = JSON.parse(localStorage.getItem('userInfo'));
          userInfo.photoURL = localStorage.getItem('pictureUrl') == null || localStorage.getItem('pictureUrl') == "null" ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" : localStorage.getItem('pictureUrl');
          localStorage.setItem('pictureUrl', '');
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
        });
        payload.self.$setPermissions(self, function () {

          payload.self.$acl.change(localStorage.getItem('permissions').split(","));

          if (localStorage.getItem('permissions').includes("Teacher")) {
            localStorage.setItem("isTeacher", "true");
          } else {
            localStorage.setItem("isTeacher", "false");
          }

          if (localStorage.getItem('permissions').includes("Student")) {
            router.push('/menu');
          } else
            router.push(router.currentRoute.query.to || '/');
          if (payload.self.$refs.login)
            payload.self.$vs.loading.close(payload.self.$refs.login.$el);
        });
      })

    });
  },
  login({
    commit,
    state
  }, payload) {
    localStorage.setItem('permissions', '');
    localStorage.setItem('userSiteInfo', '');
    localStorage.setItem('Current_User_Id', '');
    if (state.isUserLoggedIn()) {
      if (payload.self.$refs.login)
        payload.self.$vs.loading.close(payload.self.$refs.login.$el);
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }

    var success = (result) => {
      var hasRoleForDigiCEP = result.sitePermissions.filter(function (x) { return x.siteId == 31 }).length > 0;
      var hasRoleForDigiUsers = result.sitePermissions.filter(function (x) { return x.siteId == 36 }).length > 0;
      var hasRoleForSiteWithContent = result.sitePermissions.filter(function (x) { return x.siteId == Vue.prototype.$getSiteIdWithContent() }).length > 0;
      
      var permissions = result.sitePermissions.map(function (x) { return x.permissions })
      if (hasRoleForDigiUsers && (hasRoleForSiteWithContent || hasRoleForDigiCEP)) {
        var isGuardianOrStudent = permissions.filter(function (x) { return x.includes('Guardian') || x.includes('Student') }).length > 0;

        var hasSitePermissionForDigiCampus = result.sitePermissions.filter(function (x) { return x.siteId == Vue.prototype.$getSiteIdWithContent() }).length > 0;
        var hasSitePermissionWithALanguage = result.sitePermissions.filter(function (x) { return x.languageId != null }).length > 0;
        var hasSitePermissionWithAGrade = result.sitePermissions.filter(function (x) { return x.courseClassificationId != null }).length > 0;

        if (isGuardianOrStudent && hasSitePermissionForDigiCampus && hasSitePermissionWithALanguage && hasSitePermissionWithAGrade) {
          var language = result.sitePermissions.filter(function (x) { return x.languageId != null })[0].languageId;
          var grade = result.sitePermissions.filter(function (x) { return x.courseClassificationId != null })[0].courseClassificationId;
          result.languageId = language;
          result.courseClassificationId = grade;
          result.sitePermissions.filter(function (x) { return x.siteId == Vue.prototype.$getSiteIdWithContent() }).languageId = language;
          result.sitePermissions.filter(function (x) { return x.siteId == Vue.prototype.$getSiteIdWithContent() }).courseClassificationId = grade;
          var userPermissions = localStorage.getItem('permissions') + ",Student,ViewCourses";
          localStorage.setItem('permissions', userPermissions);
          localStorage.setItem('isStudent', true);
          result.isStudent = true;
        } else {
          localStorage.setItem('userInfo', JSON.stringify(result));
          Vue.prototype.$setSiteInfo(true);
        }
      }

      var data = result;
      //Set userInfo in localStorage
      var localStorageString = JSON.stringify(data);
      localStorage.setItem('userInfo', localStorageString);

      localStorage.setItem("accessToken", data.apiToken);

      localStorage.setItem('Current_User_Id', data.currentUserId);
      localStorage.setItem('DisplayName', data.displayName);
      if (data.isStudent) {
        localStorage.setItem("isStudent", "true");

        if (result.sitePermissions.length > 1) {
          var onSuccess = response => {
            if (response.data.length == 1) {
              var resultObj = {
                sitePermissions: []
              }
              resultObj.sitePermissions.push(response.data[0]);
              localStorage.setItem("userSiteInfo", JSON.stringify(response.data[0]));
              setSitePermissionsForAuth(payload, resultObj, permissions);
            } else {
              localStorage.setItem("allUserSites", JSON.stringify(response.data));
              if (localStorage.getItem("type") == "other")
                router.push('/selectsite');
              else if (localStorage.getItem("type") == "digi")
                router.push('digi/selectsite');

              return;
            }
          };
          Vue.prototype.$ajaxGet(self, "Role/GetSites", onSuccess);
          return;
        }

        setSitePermissionsForAuth(payload, result, permissions);
        return;
      }

      localStorage.setItem("isStudent", "false");
      payload.self.$getSites(self, function () {
        payload.self.$getProfilePicture(self, function () {
          var userInfo = JSON.parse(localStorage.getItem('userInfo'));
          userInfo.photoURL = localStorage.getItem('pictureUrl') == null || localStorage.getItem('pictureUrl') == "null" ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" : localStorage.getItem('pictureUrl');
          localStorage.setItem('pictureUrl', '');
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
        });
        payload.self.$setPermissions(self, function () {
          setTimeout(function () {
            payload.self.$acl.change(localStorage.getItem('permissions').split(","));

            if (localStorage.getItem('permissions').includes("Teacher") && localStorage.getItem('permissions').includes("MaintainLibraryResources")) {
              localStorage.setItem("isTeacher", "true");
            } else if (localStorage.getItem('permissions').includes("MaintainLibraryResources") && !(localStorage.getItem('permissions').includes("Teacher"))) {
              localStorage.setItem("isLibraryAdmin", "true");
            } else {
              localStorage.setItem("isTeacher", "false");
              localStorage.setItem("isLibraryAdmin", "false");
            }

            if (localStorage.getItem('permissions').includes("Admin") && payload.self.$acl.check("Teacher")) {
              router.push('/portal-select');
            } else if (payload.self.$acl.check("Teacher")) {
              router.push('/digi/teacher');
            } else if (payload.self.$acl.check("LibraryAdmin"))
              router.push('/digi/library');
            else if (payload.self.$acl.check("Mentor"))
              router.push('/mentor-dashboard');
            else if (payload.self.$acl.check("SuperAdmin")) {
              router.push('/portal-select');
            } else if (payload.self.$acl.check("Guardian")) {
               router.push('/parent/dashboard');
             }
            else if (payload.self.$acl.check("Principal")) {
              router.push('/principal/dashboard');
            }
            else if (payload.self.$acl.check("SiteAdmin")) {
              if (result.sitePermissions[0].siteTypeId == 1) {
                router.push('/portal-select');
              } else {
                let routeData = router.resolve({
                  name: 'dashboard'
                });
                window.open(routeData.href, '_self');
              }
            } else {
              let routeData = router.resolve({
                name: 'dashboard'
              });
              window.open(routeData.href, '_self');
            }
            payload.self.$vs.loading.close(payload.self.$refs.login.$el);
          }, 200)
        });
      })

    }

    if (payload.userDetails.token) {
      payload.self.$signInWithToken(payload.self, payload.userDetails.email, payload.userDetails.token, success);
    }
    else if (payload.userDetails.externalString) {
      payload.self.$signInWithEncryptedKey(payload.self, payload.userDetails.externalString, success);
    }
    else {
      payload.self.$signIn(payload.self, payload.userDetails.email, payload.userDetails.password, success);
    }

  },

  updateAuthenticatedUser({
    commit
  }, payload) {
    commit('UPDATE_AUTHENTICATED_USER', payload)
    payload.self.$vs.loading.close(payload.self.$refs.login.$el);
  }
}

function setSitePermissionsForAuth(payload, result, permissions) {
  var siteInfo = [{
    "siteId": result.sitePermissions[0].siteId,
    "name": result.sitePermissions[0].siteName,
    "logoUrl": result.sitePermissions[0].siteLogoUrl,
    "theme": "semi-dark",
    "themeColor": "#97abd8",
    "navbarColor": "#28C76F",
    "navbarType": "floating",
    "siteTypeId": result.sitePermissions[0].siteTypeId,
    "schoolPrimaryColor": result.sitePermissions[0].schoolPrimaryColor,
    "schoolSecondaryColor": result.sitePermissions[0].schoolSecondaryColor,
    "schoolTertiaryColor": result.sitePermissions[0].schoolTertiaryColor,
    "schoolFontColor": result.sitePermissions[0].schoolFontColor,
    "isMentoringAvailable": result.sitePermissions[0].isMentoringAvailable,
    "virtualClassroom": result.sitePermissions[0].virtualClassroom,
    "hasSignature": result.sitePermissions[0].hasSignature,
    "oneTaskAttempt":result.sitePermissions[0].oneTaskAttempt,
  }];
  localStorage.setItem("userSiteInfo", JSON.stringify(siteInfo));
  localStorage.setItem("pictureUrl", result.profilePictureUrl);

  var userInfo = JSON.parse(localStorage.getItem('userInfo'));
  userInfo.photoURL = localStorage.getItem('pictureUrl') == null || localStorage.getItem('pictureUrl') == "null" ? "https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" : localStorage.getItem('pictureUrl');

  userInfo.languageId = result.sitePermissions[0].languageId;
  userInfo.courseClassificationId = result.sitePermissions[0].courseClassificationId;

  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  var isGuardian = permissions.filter(function (x) { return x.includes('Guardian') }).length > 0;
  var isStudent = permissions.filter(function (x) { return x.includes('Student') }).length > 0;
  if (isGuardian && !isStudent) {
    localStorage.setItem("permissions", "Guardian,Login");
  } else if (isGuardian && isStudent) {
    localStorage.setItem("permissions", "Guardian,Student,ViewCourses,Login");
  } else {
    localStorage.setItem("permissions", "Student,ViewCourses,Login");
  }
  // localStorage.setItem("permissions", "Login,ViewCourses,Student,Login");
  payload.self.$acl.change(localStorage.getItem('permissions').split(","));
  if (localStorage.getItem('permissions').includes("Student")) {
    if (result.sitePermissions[0].siteTypeId != 1) {
      let routeData = null;
      if (result.sitePermissions[0].siteId == 33 || result.sitePermissions[0].siteId == 35) { // change to 5 for testing
        routeData = router.resolve({
          name: 'Gen2Learn'
        });
        window.open(routeData.href, '_self');
      } else if (result.sitePermissions[0].permissions.includes("Student")) {
        routeData = router.resolve({
          name: 'Menu'
        });
        window.open(routeData.href, '_self');
      }
    } else if (result.sitePermissions[0].siteTypeId == 1) {
      if (!userInfo.languageId || !userInfo.courseClassificationId) {
        // if (payload.self.$acl.check("Guardian")) {
        //   router.push('/parent/dashboard');
        // } else {
        //   router.push('/moreinfo')
        // }
      }
      else
        window.open('/digi/browsecontent',"_self");
    }
  } else
    payload.self.$vs.loading.close(payload.self.$refs.login.$el);
  return;
}
